/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function Aircraft(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.001 1.5C10.3597 1.5 10.6911 1.69246 10.8691 2.00391L13.915 7.33301H16.668C17.3752 7.33301 18.0536 7.61422 18.5537 8.11426C19.0538 8.61435 19.3349 9.29276 19.3349 10C19.3349 10.7072 19.0538 11.3856 18.5537 11.8857C18.0536 12.3858 17.3752 12.667 16.668 12.667H13.915L10.8691 17.9961C10.6911 18.3075 10.3597 18.5 10.001 18.5H7.50097C7.18749 18.4998 6.89199 18.3527 6.70311 18.1025C6.51426 17.8521 6.45394 17.5272 6.54003 17.2256L7.84179 12.667H6.24901L4.87499 14.04C4.68746 14.2275 4.43313 14.333 4.16796 14.333H1.66796C1.32155 14.3329 0.999574 14.154 0.817372 13.8594C0.635227 13.5646 0.618486 13.1957 0.773427 12.8857L2.21581 10L0.773427 7.11426C0.618486 6.80431 0.635227 6.4354 0.817372 6.14062C0.999574 5.84601 1.32155 5.66706 1.66796 5.66699H4.16796L4.26659 5.67188C4.49554 5.69457 4.71087 5.79588 4.87499 5.95996L6.24901 7.33301H7.84179L6.54003 2.77441C6.45394 2.47281 6.51426 2.14789 6.70311 1.89746C6.89199 1.64727 7.18749 1.50016 7.50097 1.5H10.001ZM10.1299 8.05859C10.216 8.3602 10.1556 8.68509 9.96679 8.93555C9.77782 9.18601 9.48171 9.33301 9.16796 9.33301H5.83495C5.5698 9.33296 5.31541 9.22753 5.12792 9.04004L3.7539 7.66699H3.28612L4.22948 9.55273C4.37016 9.83419 4.37016 10.1658 4.22948 10.4473L3.28612 12.333H3.7539L5.12792 10.96L5.20116 10.8936C5.37907 10.7478 5.60294 10.667 5.83495 10.667H9.16796C9.48171 10.667 9.77782 10.814 9.96679 11.0645C10.1556 11.3149 10.216 11.6398 10.1299 11.9414L8.82714 16.5H9.42089L12.4668 11.1709L12.54 11.0596C12.7276 10.814 13.021 10.667 13.335 10.667H16.668C16.8447 10.667 17.0146 10.5966 17.1396 10.4717C17.2647 10.3467 17.3349 10.1768 17.3349 10C17.3349 9.82319 17.2647 9.65335 17.1396 9.52832C17.0146 9.40335 16.8447 9.33301 16.668 9.33301H13.335C12.9762 9.33294 12.6448 9.14062 12.4668 8.8291L9.42089 3.5H8.82714L10.1299 8.05859Z"
        fill="#35424F"
      />
    </svg>
  )
}

Aircraft.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Aircraft
